import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ErrorToast.module.scss';

const AUTO_DISMISS_MS = 6000;

interface Props {
  message: string;
  onDismiss: () => void;
}

const ErrorToast = ({ message, onDismiss }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div className={styles.toast} role='alert' aria-live='assertive'>
      <p className={styles.message}>{message}</p>
      <button type='button' className={styles.dismiss} onClick={onDismiss} aria-label={t('error.dismiss')}>
        <svg width='14' height='14' aria-hidden='true'>
          <use href='/icons.svg#x-close' />
        </svg>
      </button>
    </div>
  );
};

export default ErrorToast;
